var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-progress-bar.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Simple progress bar component
 */
let SdsProgressBar = (() => {
    var _SdsProgressBar_text_accessor_storage, _SdsProgressBar_percent_accessor_storage, _SdsProgressBar_hint_accessor_storage, _SdsProgressBar_size_accessor_storage, _SdsProgressBar_error_accessor_storage, _SdsProgressBar_indeterminate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-progress-bar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _text_decorators;
    let _text_initializers = [];
    let _text_extraInitializers = [];
    let _percent_decorators;
    let _percent_initializers = [];
    let _percent_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _error_decorators;
    let _error_initializers = [];
    let _error_extraInitializers = [];
    let _indeterminate_decorators;
    let _indeterminate_initializers = [];
    let _indeterminate_extraInitializers = [];
    var SdsProgressBar = _classThis = class extends _classSuper {
        /**
         * Progress bar text
         * @attr
         */
        get text() { return __classPrivateFieldGet(this, _SdsProgressBar_text_accessor_storage, "f"); }
        set text(value) { __classPrivateFieldSet(this, _SdsProgressBar_text_accessor_storage, value, "f"); }
        /**
         * Progress bar percent
         * @attr
         */
        get percent() { return __classPrivateFieldGet(this, _SdsProgressBar_percent_accessor_storage, "f"); }
        set percent(value) { __classPrivateFieldSet(this, _SdsProgressBar_percent_accessor_storage, value, "f"); }
        /**
         * Progress bar hint
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsProgressBar_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsProgressBar_hint_accessor_storage, value, "f"); }
        /**
         * Progress bar size
         * @attr
         */
        get size() { return __classPrivateFieldGet(this, _SdsProgressBar_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsProgressBar_size_accessor_storage, value, "f"); }
        /**
         * True if progress bar is error
         * @attr
         */
        get error() { return __classPrivateFieldGet(this, _SdsProgressBar_error_accessor_storage, "f"); }
        set error(value) { __classPrivateFieldSet(this, _SdsProgressBar_error_accessor_storage, value, "f"); }
        /**
         * True if progress bar is indeterminate
         * @attr
         */
        get indeterminate() { return __classPrivateFieldGet(this, _SdsProgressBar_indeterminate_accessor_storage, "f"); }
        set indeterminate(value) { __classPrivateFieldSet(this, _SdsProgressBar_indeterminate_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="${this.getClasses()} ">
                ${this.renderText()}
                <div class="sds-progress-bar__line">
                    ${this.renderDeterminate()} ${this.renderIndeterminate()}
                </div>
                ${this.renderHint()}
            </div>
        `;
        }
        renderText() {
            if (this.text) {
                return html ` <div class="sds-progress-bar__text">${this.text}</div> `;
            }
        }
        renderIndeterminate() {
            if (this.indeterminate && !this.percent) {
                return html ` <div class="sds-progress-bar__line-indeterminate"></div> `;
            }
        }
        renderDeterminate() {
            if (this.percent && !this.indeterminate) {
                return html `
                <div
                    class="sds-progress-bar__line-determinate"
                    style="width: ${this.percent}"
                ></div>
            `;
            }
        }
        renderHint() {
            if (this.hint) {
                return html ` <div class="sds-progress-bar__hint">${this.hint}</div> `;
            }
        }
        getClasses() {
            return classMap({
                'sds-progress-bar': true,
                'sds-progress-bar--lg': this.size === 'lg',
                'sds-progress-bar--sm': this.size === 'sm',
                'sds-progress-bar--error': this.error,
            });
        }
        constructor() {
            super(...arguments);
            _SdsProgressBar_text_accessor_storage.set(this, __runInitializers(this, _text_initializers, ''));
            _SdsProgressBar_percent_accessor_storage.set(this, (__runInitializers(this, _text_extraInitializers), __runInitializers(this, _percent_initializers, '')));
            _SdsProgressBar_hint_accessor_storage.set(this, (__runInitializers(this, _percent_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsProgressBar_size_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _size_initializers, 'lg')));
            _SdsProgressBar_error_accessor_storage.set(this, (__runInitializers(this, _size_extraInitializers), __runInitializers(this, _error_initializers, false)));
            _SdsProgressBar_indeterminate_accessor_storage.set(this, (__runInitializers(this, _error_extraInitializers), __runInitializers(this, _indeterminate_initializers, false)));
            __runInitializers(this, _indeterminate_extraInitializers);
        }
    };
    _SdsProgressBar_text_accessor_storage = new WeakMap();
    _SdsProgressBar_percent_accessor_storage = new WeakMap();
    _SdsProgressBar_hint_accessor_storage = new WeakMap();
    _SdsProgressBar_size_accessor_storage = new WeakMap();
    _SdsProgressBar_error_accessor_storage = new WeakMap();
    _SdsProgressBar_indeterminate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsProgressBar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _text_decorators = [property({ type: String })];
        _percent_decorators = [property({ type: String })];
        _hint_decorators = [property({ type: String })];
        _size_decorators = [property({ type: String })];
        _error_decorators = [property({ type: Boolean })];
        _indeterminate_decorators = [property({ type: Boolean })];
        __esDecorate(_classThis, null, _text_decorators, { kind: "accessor", name: "text", static: false, private: false, access: { has: obj => "text" in obj, get: obj => obj.text, set: (obj, value) => { obj.text = value; } }, metadata: _metadata }, _text_initializers, _text_extraInitializers);
        __esDecorate(_classThis, null, _percent_decorators, { kind: "accessor", name: "percent", static: false, private: false, access: { has: obj => "percent" in obj, get: obj => obj.percent, set: (obj, value) => { obj.percent = value; } }, metadata: _metadata }, _percent_initializers, _percent_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(_classThis, null, _error_decorators, { kind: "accessor", name: "error", static: false, private: false, access: { has: obj => "error" in obj, get: obj => obj.error, set: (obj, value) => { obj.error = value; } }, metadata: _metadata }, _error_initializers, _error_extraInitializers);
        __esDecorate(_classThis, null, _indeterminate_decorators, { kind: "accessor", name: "indeterminate", static: false, private: false, access: { has: obj => "indeterminate" in obj, get: obj => obj.indeterminate, set: (obj, value) => { obj.indeterminate = value; } }, metadata: _metadata }, _indeterminate_initializers, _indeterminate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsProgressBar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsProgressBar = _classThis;
})();
export { SdsProgressBar };
